import React from "react";
import ScrollIntoView from "../components/ScrollIntoView";

const Public = () => {
  return (
    <ScrollIntoView>
      <div id="public-page">
        <section>
          <h1>Közérdekű adatok</h1>

          <div id="public-links">
            <a
              href="/kozerdeku/2019. évi egyszerűsített évesbeszámoló.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              2019. évi egyszerűsített évesbeszámoló
            </a>
            <a
              href="/kozerdeku/2019. évi kiegészítő melléklet.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              2019. évi kiegészítő melléklet
            </a>
            <a
              href="/kozerdeku/Egyszerűsített évesbeszámoló 2020.év.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Egyszerűsített évesbeszámoló 2020.év
            </a>
            <a
              href="/kozerdeku/Kiegészítő melléklet 2020.év.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kiegészítő melléklet 2020.év
            </a>
            <a
              href="/kozerdeku/Foglalkoztatottak létszáma személyi juttatása 2018.III.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Foglalkoztatottak létszáma személyi juttatása 2018.III
            </a>
            <a
              href="/kozerdeku/Adatvédelmi szabályzat.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Adatvédelmi szabályzat
            </a>
          </div>
        </section>
      </div>
    </ScrollIntoView>
  );
};

export default Public;
